import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  zh: {
    translation: {
      title: '实时收入计算器',
      yearlyIncome: '年收入:',
      inputYearlyIncome: '输入年收入',
      realtimeIncomeRate: '实时收入速率',
      perSecond: '每秒',
      perMinute: '每分钟',
      perHour: '每小时',
      perDay: '每天',
      earnedSoFar: '已累计收入',
      timing: '计时中...',
      paused: '已暂停',
      pause: '暂停',
      resume: '继续',
      reset: '重置',
    },
  },
  en: {
    translation: {
      title: 'Real-time Income Calculator',
      yearlyIncome: 'Yearly Income:',
      inputYearlyIncome: 'Enter yearly income',
      realtimeIncomeRate: 'Real-time Income Rate',
      perSecond: 'Per Second',
      perMinute: 'Per Minute',
      perHour: 'Per Hour',
      perDay: 'Per Day',
      earnedSoFar: 'Total Earned',
      timing: 'Timing...',
      paused: 'Paused',
      pause: 'Pause',
      resume: 'Resume',
      reset: 'Reset',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'zh',
    fallbackLng: 'zh',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 